/*
 * @Author: lzz
 * @Date: 2024-06-08 10:27:41
 * @LastEditTime: 2024-08-02 11:05:26
 */
// import '@babel/polyfill'
import promise from 'es6-promise'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
promise.polyfill()

import Vue from 'vue'
import App from './App.vue'
import router from './router/router';
import Carousel3d from 'vue-carousel-3d';
import "@/assets/icons/index";
import 'element-ui/lib/theme-chalk/index.css';
import autofit from 'autofit.js'
import {
  Message,
  Select,
  Option,
  Input,
  Button,
  Cascader,
  Dialog,
  Loading,
  Image,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Popconfirm
} from 'element-ui';
// import vueEsign from 'vue-esign'
// Vue.use(vueEsign)
Vue.component(Message.name, Message);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Button);
Vue.use(Cascader);
Vue.use(Loading);
Vue.use(Image);
Vue.use(Tooltip);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popconfirm);
Vue.prototype.$message = Message;
// 下边的用啥解啥
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox.alert;
// Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;

Vue.use(Carousel3d);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
